// @flow

import React, { Fragment } from 'react'
import styled from 'styled-components'
import moment from 'moment'
import { fontSize, spacing } from 'frontend_core/dist/styles/variables'
import Colors from 'components/styles/colors'
import Button from 'components/atoms/Button'

const StatusDesc = styled.pre`
  margin-top: ${spacing.small_2}px;
  color: ${Colors.gray9};
  font-size: ${fontSize.small_2}px;
  text-align: center;
  line-height: 1.454;
  white-space: pre-wrap;
`
const LabelHeader = styled.p`
  font-size: ${fontSize.small_3}px;
  font-weight: bold;
  text-align: center;

  &:not(:first-of-type) {
    margin-top: ${spacing.small}px;
  }
`
const ButtonWrapper = styled.div`
  margin-top: ${spacing.small_3}px;
`

type PropTypes = {
  onClickItinerary: Function,
}

export default function ReservationUseScheduleBlock(props: PropTypes) {
  return (
    <Fragment>
      <LabelHeader>
        {i18n.t('page.dashboard.inbox.shareReservation')}
      </LabelHeader>
      <StatusDesc>
        {i18n.t('page.dashboard.inbox.shareReservationDesc')}
      </StatusDesc>
      <ButtonWrapper>
        <Button
          tag="anchor"
          buttonType="large"
          colorType="blue"
          fullWidthSp
          href="#"
          onClick={props.onClickItinerary}
        >
          {i18n.t('page.dashboard.inbox.showReservation')}
        </Button>
      </ButtonWrapper>
    </Fragment>
  )
}



// WEBPACK FOOTER //
// ./src/components/molecules/ReservationUseScheduleBlock/index.jsx